import React, { FC } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ReportProblemTwoToneIcon from "@mui/icons-material/ReportProblemTwoTone";
import { Typography } from "@mui/material";


interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const Mudarvistatecnicoadmin: FC<ConfirmDialogProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent id="alert-dialog-description">
                <ReportProblemTwoToneIcon
                    sx={{ color: "orange", fontSize: 60 }}
                />
                <Typography
                    align="center"
                    fontFamily="Candara"
                    fontWeight={700}
                    fontSize={20}
                    color="#7e2706"
                >
                    Certifique-se de que gravou toda a informação antes de mudar.
                </Typography>
            </DialogContent>
            <Typography
                align="center"
                fontFamily="Candara"
                color="#7e2706"
                fontWeight={700}
                fontSize={18}
                padding={1}
            >
                Deseja Continuar?
            </Typography>
            <DialogActions>
                <Button
                    color="secondary"
                    onClick={onConfirm}
                    sx={{
                        color: "#7e2706",
                        fontFamily: "candara",
                        fontSize: 18,
                    }}
                >
                    Sim
                </Button>
                <Button
                    onClick={onClose}
                    sx={{
                        color: "#7e2706",
                        fontFamily: "candara",
                        fontSize: 18,
                    }}
                >
                    Não
                </Button>

            </DialogActions>
        </Dialog>
    );
};

export default Mudarvistatecnicoadmin;
